import TrainingLayout from "./TrainingLayout";
export default TrainingLayout;
